export enum EConversationStatus {
	all = "all",
	active = "active",
	archived = "archived"
}
